module.exports = __webpack_public_path__ + "static/media/gry-edukacyjne-dla-6-latka-7-latka.900ec7af.png";